




























import { Component, Vue } from "vue-property-decorator";
import { RoutesList}  from "@/router.ts"
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseApi from "@/core/HttpResources/BaseApi";
import * as signalR from "@aspnet/signalr";

@Component({})
export default class BottomNavigationComponent extends Vue {
    menuSections = RoutesList.getMobileMenu()

  constructor() {
    super();
  }

  get user() {
    return this.$store.state.user;
  }
   get isQuickReference() {
    return !!this.$route.params.cedula;
  }
 get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
      return this.$store.state.isMobile;
  }
//   changeSection(menu: any) {
//     this.menuSections.map((x) => {
//       x.isActive = false;
//     });
//     menu.isActive = true;
//     //
//     this.$store.dispatch('mobileSectionChange', menu);
//     this.$router.push('/MobileMenuTemplate');
//   }

  showParent(item: any) {
    return (
       this.user.isAdmin ||
        this.user.permissions.some(
          (x: any) =>  item.permissionValues.some((y:any)=> y == x.permissionValue)
        )
    );
  }

  mounted() {
    // var x = this.menuSections[0];
    // this.changeSection(x);
  }

  logOut() {
    this.$buefy.dialog.confirm({
      title: "Cerrar sesión",
      message: `<span style='color:black;'> ¿Desea cerrar sesión? </span>`,
      cancelText: 'Cancelar',
      confirmText: "Cerrar sesión",
      icon: "power",
      type: "is-red",
      hasIcon: true,
      onConfirm: () => {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      }
    });
  }
  sendToLogin(){
     this.$buefy.dialog.confirm({
      title: "Terminar consulta",
      message: `<span style='color:black;'> ¿Desea terminar la consulta? </span>`,
      cancelText: 'Cancelar',
      confirmText: "Terminar consulta",
      icon: "power",
      type: "is-red",
      hasIcon: true,
      onConfirm: () => {
         this.$router.push("/login");
      }
    });
  }

}
